import { useEffect, useState } from "react";

export default function ImageWithFallback({
  src,
  fallbackSrc,
  alt,
  ...restProps
}) {
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    setImageSrc(src);
  }, [src]);

  const onError = () => {
    setImageSrc(fallbackSrc ?? "");
  };

  return <img src={imageSrc} alt={alt} onError={onError} {...restProps} />;
}
